import { useMemo } from "react";
import { required, SelectInput, TextInput } from "react-admin";
import { useWatch } from "react-hook-form";
import { SiteContryEnum, SiteOperatorEnum } from "shared/enums/globalEnums";
import {
  siteFinlandDsoChoices,
  siteFinlandSupplierChoices,
  siteFranceSupplierChoices,
  siteFrenchDsoChoices,
  siteOperatorChoices,
} from "shared/enums/reactAdminChoices";

type CountryDependentInputsProps = {
  isCreateForm: boolean;
};

export const CountryDependentInputs = ({ isCreateForm }: CountryDependentInputsProps) => {
  const country = useWatch({ name: "country" });

  const isFinland = country === SiteContryEnum.Finland;
  const disabled = !country;
  const helperText = disabled ? "You must choose a country first" : undefined;

  const dsoChoices = isFinland ? siteFinlandDsoChoices : siteFrenchDsoChoices;
  const supplierChoices = isFinland ? siteFinlandSupplierChoices : siteFranceSupplierChoices;

  const operatorChoices = useMemo(() => {
    return siteOperatorChoices.filter(({ id }) => {
      const finlandOperatorChoices = [SiteOperatorEnum.NWJ_FIN_Oy, SiteOperatorEnum.NWJ_FIN_2_Oy];
      const siteOperatorIsFinland = finlandOperatorChoices.includes(id as SiteOperatorEnum);
      return isFinland ? siteOperatorIsFinland : !siteOperatorIsFinland;
    });
  }, [isFinland]);

  const defaultInputProps = {
    disabled,
    helperText,
    validate: isCreateForm ? [required()] : [],
  };

  return (
    <>
      <SelectInput fullWidth source="dso" choices={dsoChoices} {...defaultInputProps} />
      <SelectInput fullWidth source="site_operator" choices={operatorChoices} label="SPV" {...defaultInputProps} />
      <SelectInput fullWidth source="supplier" choices={supplierChoices} {...defaultInputProps} />
      <TextInput
        fullWidth
        source="prm"
        label={isFinland ? "Consumption point number (GSRN)" : "PRM"}
        {...defaultInputProps}
      />
    </>
  );
};
